__turbopack_context__.v({
  "avatar": "aHjAkW_avatar",
  "avatarImage": "aHjAkW_avatarImage",
  "avatarInitials": "aHjAkW_avatarInitials",
  "card": "aHjAkW_card",
  "countBlock": "aHjAkW_countBlock",
  "countLabel": "aHjAkW_countLabel",
  "countNumber": "aHjAkW_countNumber",
  "expander": "aHjAkW_expander",
  "focusRow": "aHjAkW_focusRow",
  "focusTag": "aHjAkW_focusTag",
  "header": "aHjAkW_header",
  "headerMain": "aHjAkW_headerMain",
  "nameRow": "aHjAkW_nameRow",
  "newCount": "aHjAkW_newCount",
  "plCard": "aHjAkW_plCard",
  "roleList": "aHjAkW_roleList",
  "teamName": "aHjAkW_teamName",
});
